<template>
  <zj-layout-container v-loading="loading" :element-loading-text="loadingText">
    <zj-layout-header>
      <div class="listtitle">物资仓库信息</div>
      <el-form class="zj-search-form clear" ref="form" :model="form" :label-width="labelWidth">
        <el-form-item label="仓库名称">
          <el-input v-model="name"></el-input>
        </el-form-item>
        <el-form-item label class="right">
          <el-button @click="onSearch">查 询</el-button>
          <el-button @click="onCancel">清 理</el-button>
        </el-form-item>
      </el-form>
      <el-divider></el-divider>
    </zj-layout-header>
    <zj-layout-main style="padding-top:0px;">
      <zj-layout-container>
        <zj-layout-header>
          <div class="zj-button-bar">
            <el-button size="mini" @click="onAdd">添 加</el-button>
            <el-button size="mini" @click="onbatchDel">删 除</el-button>
          </div>
        </zj-layout-header>
        <zj-layout-main style="padding:0.8rem 0px 0px 0px;">
          <el-table
            :data="tableData"
            ref="multipleTable"
            @selection-change="selectionChange"
            border
            style="width: 100%"
            height="100%"
          >
            <el-table-column type="selection" width="40" align="center"></el-table-column>
            <el-table-column type="index" label="序号" width="80" align="center"></el-table-column>
            <el-table-column prop="name" label="仓库名称"></el-table-column>
            <el-table-column prop="belongEnterprise" label="所属企业" align="center"></el-table-column>
            <el-table-column prop="warehouseArea" label="仓库面积" align="center"></el-table-column>
            <el-table-column prop="address" label="仓库地点" align="center"></el-table-column>
            <el-table-column prop="responsiblePerson" label="负责人" align="center"></el-table-column>
            <el-table-column prop="mobileNo" label="移动电话" align="center"></el-table-column>
            <el-table-column label="操作" width="130" align="center">
              <template slot-scope="scope">
                <el-button @click="handleClick(scope.$index,scope.row)" type="text" size="small">查看</el-button>
                <el-button @click="editClick(scope.$index,scope.row)" type="text" size="small">编辑</el-button>
                <el-button @click="deleteClick(scope.$index,scope.row)" type="text" size="small">删除</el-button>
              </template>
            </el-table-column>
          </el-table>
        </zj-layout-main>
      </zj-layout-container>
    </zj-layout-main>
    <zj-layout-footer>
      <el-pagination
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :current-page="currentPage"
        :page-sizes="[10, 20, 50, 100]"
        :page-size="pageSize"
        layout="total, sizes, prev, pager, next, jumper"
        background
        :total="total"
      ></el-pagination>
    </zj-layout-footer>
  </zj-layout-container>
</template>

<script>
import { warehouseList, warehouseRemove } from '@/api/src/emergency_warehouse'
export default {
  name: "ZjMaterialWarehouselist",
  controller: "UI",
  action: "MaterialWarehouselist",
  data() {
    return {
      loading: false,
      loadingText: "加载中...",
      currentPage: 1,
      pageSize: 20,
      total: 0,
      tableData: [],
      name: "",
      selectData: null
    };
  },
  mounted: function() {
    this.search();
  },
  methods: {
    // 表格的选中 可以获得当前选中的数据
    selectionChange(val) {
      // 将选中的数据存储起来
      this.selectData = val;
    },
    search() {
      let searchInfo = {
        name: this.name,
        size: this.pageSize,
        current: this.currentPage
      };
      this.loading = true;
      this.loadingText = "加载中...";
      warehouseList(searchInfo)
        .then(r => {
          r = r.data;
          this.tableData = r.records;
          this.total = r.total;
          this.loading = false;
        })
        .catch(e => {
          console.error(e);
          this.loading = false;
        });
    },
    clearsearch() {
      this.name = "";
    },
    // 点击查询按钮
    onSearch() {
      this.currentPage = 1;
      this.search();
    },
    // 点击取消按钮
    onCancel() {
      this.clearsearch();
      this.search();
    },
    //编辑按钮
    editClick(index, row) {
      console.log(row)
      this.$router.push({
        path: "/plugin/emergency/ui/MaterialWarehouseinfo",
        // name: 'mallList',
        query: {
          id: row.id,
          type: "edit"
        }
      });
    },
    //查看详细
    handleClick(index, row) {
      this.$router.push({
        path: "/plugin/emergency/ui/MaterialWarehouseinfo",
        // name: 'mallList',
        query: {
          id: row.id,
          type: "search"
        }
      });
    },
    //添加
    onAdd() {
      this.$router.push({
        path: "/plugin/emergency/ui/MaterialWarehouseinfo",
        // name: 'mallList',
        query: {
          id: "",
          type: "edit"
        }
      });
    },
    //批量删除
    onbatchDel() {
      if (
        this.selectData != undefined &&
        this.selectData != null &&
        this.selectData.length > 0
      ) {
        this.$confirm("选中的数据将被永久删除, 是否继续?", "提示", {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning"
        }).then(() => {
          let selectData = []
          this.selectData.forEach(item => {
            selectData.push(item.id)
          });
          const count = selectData.length;
          console.log(selectData, typeof selectData, selectData instanceof Array)
          console.log(selectData.toString())
          // 清除 所有勾选项
          this.$refs.multipleTable.clearSelection();
          if (count > 0) {
            const that = this;
              console.log(selectData.toString());
                that.loading = true;
                that.loadingText = "删除中...";
                warehouseRemove({ idList: selectData.toString()})
                  .then(r => {
                    if (r.data) {
                      that.$message({
                        type: "success",
                        message: "删除成功!"
                      });
                    } else {
                      that.$message({
                        type: "error",
                        message: "删除失败!"
                      });
                    }
                    that.loading = false;
                    that.search();
                  })
                  .catch(e => {
                    console.error(e);
                    that.loading = false;
                  });
          }
        });
      } else {
        this.$message({
          type: "info",
          message: "未选中任何行！"
        });
      }
    },
    //行删除
    deleteClick(index, row) {
      console.log(row.id)
      this.$confirm("此操作将永久删除该行数据, 是否继续?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
      }).then(() => {
            const that = this;
            that.loading = true;
            that.loadingText = "删除中...";
            console.log(row.id)
            warehouseRemove({ idList :row.id })
              .then(r => {
                r = r.data;
                if (r) {
                  that.$message({
                    type: "success",
                    message: "删除成功!"
                  });
                } else {
                  that.$message({
                    type: "error",
                    message: "删除失败!"
                  });
                }
                that.loading = false;
                that.search();
              })
              .catch(e => {
                console.error(e);
                that.loading = false;
              });
      });
    },
    handleSizeChange(val) {
      this.pageSize = val;
      this.search();
    },
    handleCurrentChange(val) {
      this.currentPage = val;
      this.search();
    },
    //日期列表展示格式
    formatDate(row, column) {
      // 获取单元格数据
      let data = row[column.property];
      if (data == null || data == "0001-01-01T00:00:00") {
        return null;
      }
      return new Date(data).format("yyyy-MM-dd hh:mm:ss");
    }
  }
};
</script>